import { useReducer } from "react";
/**
 * This function wrapper normal useReducer function and log the action info
 * only in dev mode
 * @param {*} reducer
 * @param {*} initialState
 */
const useReducerWithLogging = (reducer, initialState) => {
    const reducerWithLogging = (state, action) => {
        if (process.env.NODE_ENV === "development") {
            console.info(`[${action.type}]`, { action, state });
        }
        return reducer(state, action);
    };
    return useReducer(reducerWithLogging, initialState);
};

export { useReducerWithLogging };
